import React, { forwardRef } from 'react';
import {
  useLocation,
  useParams,
} from 'react-router-dom';
import {
  Checkbox, Radio
} from 'semantic-ui-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import DatesRangeInput from '../DatesRangeInput/DatesRangeInput';

const CommonFilterList = forwardRef((
  {
    checkValue,
    radioValue,
    datesRange,
    handleRadioChange,
    handleCheckChange,
    handleDateRange,
    translate,
    useLeakage,
  },
  ref
) => {
  const location = useLocation();
  const params = useParams();
  const pathName = location.pathname;
  const currentLocale = localStorage.getItem('i18nextLng');

  return (
    <Scrollbars
      renderTrackHorizontal={() => {
        return <div />;
      }}
      renderThumbHorizontal={() => {
        return <div />;
      }}
      autoHeight
      autoHeightMin={310}
    >
      <div className="common_filter_contents">
        <div className="common_filter_contents_inner">
          {
            pathName === '/results/overview'
            && (
              <div className="common_filter_item">
                <p className="title">{translate('contents_header.menu.scan_status')}</p>
                <div className="checkbox_wrap">
                  <ul>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.queue')}
                        value="rstatus_qu"
                        checked={checkValue.indexOf('rstatus_qu') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.scanning')}
                        value="rstatus_sc"
                        checked={checkValue.indexOf('rstatus_sc') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.success')}
                        value="rstatus_su"
                        checked={checkValue.indexOf('rstatus_su') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.fail')}
                        value="rstatus_fa"
                        checked={checkValue.indexOf('rstatus_fa') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            )
          }
          {
            pathName === '/results/overview'
            && (
              <div className="common_filter_item">
                <p className="title">{translate('contents_header.link_header.scan_method')}</p>
                <div className="checkbox_wrap">
                  <ul>
                    <li>
                      <Checkbox
                        label={translate('contents_header.link_header.sbom_import')}
                        value="smethod_s"
                        checked={checkValue.indexOf('smethod_s') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.link_header.clarity_scan')}
                        value="smethod_c"
                        checked={checkValue.indexOf('smethod_c') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            )
          }
          {
            (pathName === '/results/overview' || pathName === '/results/overview/project')
            && (
              <div className="common_filter_item">
                <p className="title">
                  {
                    pathName.indexOf('project') !== -1 ? (
                      translate('contents_header.menu.project_grade')
                    ) : (
                      translate('contents_header.menu.uploaded_file_grade')
                    )
                  }
                </p>
                <div className="checkbox_wrap">
                  <ul>
                    <li>
                      <Checkbox
                        label="A"
                        value="grade_a"
                        checked={checkValue.indexOf('grade_a') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label="B"
                        value="grade_b"
                        checked={checkValue.indexOf('grade_b') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label="C"
                        value="grade_c"
                        checked={checkValue.indexOf('grade_c') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label="D"
                        value="grade_d"
                        checked={checkValue.indexOf('grade_d') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            )
          }
          {
            (pathName.indexOf('overview') !== -1
            || pathName === '/results/component'
            || pathName.indexOf('results/component/binary') !== -1
            || (pathName.indexOf('security') !== -1 && pathName.indexOf('cnvd') === -1)
            || pathName === '/results/component'
            )
            && (
              <div className="common_filter_item">
                <p className="title">{translate('contents_header.menu.security_risk_severity')}</p>
                <div className="checkbox_wrap">
                  <ul>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.critical')}
                        value="security_c"
                        checked={checkValue.indexOf('security_c') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.high')}
                        value="security_h"
                        checked={checkValue.indexOf('security_h') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.medium')}
                        value="security_m"
                        checked={checkValue.indexOf('security_m') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.low')}
                        value="security_l"
                        checked={checkValue.indexOf('security_l') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            )
          }
          {pathName.indexOf('security') > -1
            && pathName.indexOf(params.idReport) > -1
            && pathName.indexOf('cnvd') === -1 && (
            <div className="common_filter_item">
              <p className="title">{translate('list.title.status')}</p>
              <div className="checkbox_wrap">
                <ul>
                  <li>
                    <Checkbox
                      label={translate('list.title.vulnerable')}
                      value="status_v"
                      checked={checkValue.indexOf('status_v') > -1}
                      onChange={handleCheckChange}
                    />
                  </li>
                  <li>
                    <Checkbox
                      label={translate('list.title.fixed')}
                      value="status_f"
                      checked={checkValue.indexOf('status_f') > -1}
                      onChange={handleCheckChange}
                    />
                  </li>
                  <li>
                    <Checkbox
                      label={translate('list.title.not_affected')}
                      value="status_n"
                      checked={checkValue.indexOf('status_n') > -1}
                      onChange={handleCheckChange}
                    />
                  </li>
                </ul>
              </div>
            </div>
          )}
          {
            (pathName.indexOf('cnvd') > -1)
            && (
              <div className="common_filter_item">
                <p className="title">{translate('contents_header.menu.security_risk_severity')}</p>
                <div className="checkbox_wrap">
                  <ul>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.high')}
                        value="cnvd_h"
                        checked={checkValue.indexOf('cnvd_h') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.medium')}
                        value="cnvd_m"
                        checked={checkValue.indexOf('cnvd_m') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.low')}
                        value="cnvd_l"
                        checked={checkValue.indexOf('cnvd_l') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            )
          }
          {
            pathName.indexOf('issue') !== -1
            && (
              <div className="common_filter_item">
                <p className="title">{translate('contents_header.menu.security_issue_status')}</p>
                <div className="checkbox_wrap">
                  <ul>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.undecided')}
                        value="status_sc_u"
                        checked={checkValue.indexOf('status_sc_u') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.resolved')}
                        value="status_sc_r"
                        checked={checkValue.indexOf('status_sc_r') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.disregarded')}
                        value="status_sc_d"
                        checked={checkValue.indexOf('status_sc_d') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            )
          }
          {
            (pathName.indexOf('overview') !== -1
            || pathName === '/results/component'
            || pathName.indexOf('results/component/binary') !== -1
            )
            && (
              <div className="common_filter_item">
                <p className="title">{translate('contents_header.menu.license_family')}</p>
                <div className="checkbox_wrap">
                  <ul>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.protective')}
                        value="license_pt"
                        checked={checkValue.indexOf('license_pt') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.permissive')}
                        value="license_pm"
                        checked={checkValue.indexOf('license_pm') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.others')}
                        value="license_o"
                        checked={checkValue.indexOf('license_o') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            )
          }
          {
            pathName.indexOf('issue') !== -1
            && (
              <div className="common_filter_item">
                <p className="title">{translate('contents_header.menu.license_issue_status')}</p>
                <div className="checkbox_wrap">
                  <ul>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.undecided')}
                        value="status_lc_u"
                        checked={checkValue.indexOf('status_lc_u') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.resolved')}
                        value="status_lc_r"
                        checked={checkValue.indexOf('status_lc_r') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.disregarded')}
                        value="status_lc_d"
                        checked={checkValue.indexOf('status_lc_d') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            )
          }
          {
            pathName.indexOf('license') !== -1 && pathName.indexOf('litigator') === -1
            && (
              <div className="common_filter_item">
                <p className="title">{translate('contents_header.menu.license_family')}</p>
                <div className="checkbox_wrap">
                  <ul>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.protective')}
                        value="license_pt"
                        checked={checkValue.indexOf('license_pt') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.permissive')}
                        value="license_pm"
                        checked={checkValue.indexOf('license_pm') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.others')}
                        value="license_o"
                        checked={checkValue.indexOf('license_o') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            )
          }
          {
            (pathName.indexOf('overview') !== -1 && pathName.indexOf(params.idReport) === -1
            )
            && (
              <div className="common_filter_item">
                <p className="title">{translate('contents_header.menu.litigator')}</p>
                <div className="checkbox_wrap">
                  <ul>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.applicable')}
                        value="litigator_a"
                        checked={checkValue.indexOf('litigator_a') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            )
          }
          {
            pathName === '/results/overview' && useLeakage
            && (
              <div className="common_filter_item">
                <p className="title">{translate('modal.leakage_info.leakage')}</p>
                <div className="checkbox_wrap">
                  <ul>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.applicable')}
                        value="leakage_a"
                        checked={checkValue.indexOf('leakage_a') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            )
          }
          {
            pathName.indexOf('issue') !== -1
            && (
              <div className="common_filter_item">
                <p className="title">{translate('contents_header.menu.litigator_issue_status')}</p>
                <div className="checkbox_wrap">
                  <ul>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.undecided')}
                        value="status_lt_u"
                        checked={checkValue.indexOf('status_lt_u') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.resolved')}
                        value="status_lt_r"
                        checked={checkValue.indexOf('status_lt_r') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.disregarded')}
                        value="status_lt_d"
                        checked={checkValue.indexOf('status_lt_d') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            )
          }
          {
            (
              (pathName.indexOf('overview') !== -1 && pathName.indexOf(params.idReport) !== -1)
              || (pathName.indexOf('component') !== -1 && pathName.indexOf(params.idReport) !== -1)
              || pathName === '/results/component'
            )
            && (
              <div className="common_filter_item">
                <p className="title">
                  {translate('contents_header.menu.litigator_code')}
                </p>
                <div className="checkbox_wrap">
                  <ul>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.mchardy')}
                        value="litigator_mc"
                        checked={checkValue.indexOf('litigator_mc') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.sfc')}
                        value="litigator_sf"
                        checked={checkValue.indexOf('litigator_sf') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.patent')}
                        value="litigator_pt"
                        checked={checkValue.indexOf('litigator_pt') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            )
          }
          {
            pathName === '/results/license/project'
            && (
              <div className="common_filter_item">
                <p className="title">
                  {translate('contents_header.menu.litigator_code')}
                </p>
                <div className="checkbox_wrap">
                  <ul>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.all')}
                        value="litigator_a"
                        checked={checkValue.indexOf('litigator_a') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            )
          }
          {
            pathName.indexOf('results/overview/binary') !== -1
            && (
              <div className="common_filter_item">
                <p className="title">{translate('contents_header.menu.match_type')}</p>
                <div className="checkbox_wrap">
                  <ul>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.identifier_matching')}
                        value="match_i"
                        checked={checkValue.indexOf('match_i') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.hash_matching')}
                        value="match_h"
                        checked={checkValue.indexOf('match_h') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.fuzzy_matching')}
                        value="match_f"
                        checked={checkValue.indexOf('match_f') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.manifest_matching')}
                        value="match_m"
                        checked={checkValue.indexOf('match_m') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.user_defined')}
                        value="match_u"
                        checked={checkValue.indexOf('match_u') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            )
          }

          {(pathName === '/results/overview' || pathName === '/results/overview/project')
          && (
            <div className="common_filter_item">
              <p className="title">{translate('contents_header.menu.violated_policy')}</p>
              <div className="checkbox_wrap">
                <ul>
                  <li>
                    <Checkbox
                      label={translate('contents_header.menu.applicable')}
                      value="policy_a"
                      checked={checkValue.indexOf('policy_a') > -1}
                      onChange={handleCheckChange}
                    />
                  </li>
                </ul>
              </div>
            </div>
          )}
          {
            pathName.indexOf('policy/project') !== -1 && pathName.indexOf(params.idReport) !== -1
            && (
              <div className="common_filter_item">
                <p className="title">{translate('contents_header.menu.policy_coverage')}</p>
                <div className="checkbox_wrap">
                  <ul>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.company')}
                        value="coverage_c"
                        checked={checkValue.indexOf('coverage_c') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.project')}
                        value="coverage_p"
                        checked={checkValue.indexOf('coverage_p') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            )
          }
          {
            pathName.indexOf('policy') !== -1
            && (
              <div className="common_filter_item">
                <p className="title">{translate('contents_header.menu.policy_category')}</p>
                <div className="checkbox_wrap">
                  <ul>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.component')}
                        value="policy_cp"
                        checked={checkValue.indexOf('policy_cp') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.security')}
                        value="policy_sc"
                        checked={checkValue.indexOf('policy_sc') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.license')}
                        value="policy_lc"
                        checked={checkValue.indexOf('policy_lc') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                    <li>
                      <Checkbox
                        label={translate('contents_header.menu.litigator')}
                        value="policy_lt"
                        checked={checkValue.indexOf('policy_lt') > -1}
                        onChange={handleCheckChange}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            )
          }

          {(
            pathName === '/results/overview'
            || pathName === '/results/overview/project'
            || pathName === '/results/component/project'
            || pathName === '/results/security/project'
            || pathName === '/results/license/project'
          )
          && (
            <div className="common_filter_item">
              <p className="title">{translate('contents_header.menu.last_uploaded_date')}</p>
              <div className=" radio_wrap">
                <ul>
                  <li>
                    <Radio
                      label={translate('contents_header.menu.any_time')}
                      value="udtime_any"
                      checked={radioValue === 'udtime_any'}
                      onChange={handleRadioChange}
                    />
                  </li>
                  <li>
                    <Radio
                      label={translate('contents_header.menu.past_24_hours')}
                      value="udtime_p24"
                      checked={radioValue === 'udtime_p24'}
                      onChange={handleRadioChange}
                    />
                  </li>
                  <li>
                    <Radio
                      label={translate('contents_header.menu.past_week')}
                      value="udtime_pw"
                      checked={radioValue === 'udtime_pw'}
                      onChange={handleRadioChange}
                    />
                  </li>
                  <li>
                    <Radio
                      label={translate('contents_header.menu.past_month')}
                      value="udtime_pm"
                      checked={radioValue === 'udtime_pm'}
                      onChange={handleRadioChange}
                    />
                  </li>
                  <li>
                    <Radio
                      label={translate('contents_header.menu.custom_range')}
                      value="udtime_cr"
                      checked={radioValue === 'udtime_cr'}
                      onChange={handleRadioChange}
                    />
                    <div className="date_range_picker_wrap" ref={ref}>
                      {radioValue === 'udtime_cr' ? (
                        <DatesRangeInput
                          className="date_range"
                          name="datesRange"
                          placeholder={translate('contents_header.place_holder.from_to')}
                          value={datesRange}
                          iconPosition="left"
                          onChange={handleDateRange}
                          dateFormat={currentLocale === 'kr' || currentLocale === 'ja' ? 'YYYY-MM-DD' : 'DD-MM-YYYY'}
                          closable
                          closeOnMouseLeave={false}
                        />
                      ) : null}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {
            (
              pathName === '/results/license'
              || pathName === '/results/component'
              || pathName === '/results/security'
              || pathName === '/results/license/litigator'
              || pathName === '/results/policy'
              || pathName === '/results/policy/project'
              || (pathName.indexOf('policy/binary') !== -1 && pathName.indexOf(params.idReport) !== -1)
            )
            && (
              <div className="common_filter_item">
                <p className="title">{translate('contents_header.menu.last_detected_date')}</p>
                <div className=" radio_wrap">
                  <ul>
                    <li>
                      <Radio
                        label={translate('contents_header.menu.any_time')}
                        value="dttime_any"
                        checked={radioValue === 'dttime_any'}
                        onChange={handleRadioChange}
                      />
                    </li>
                    <li>
                      <Radio
                        label={translate('contents_header.menu.past_24_hours')}
                        value="dttime_p24"
                        checked={radioValue === 'dttime_p24'}
                        onChange={handleRadioChange}
                      />
                    </li>
                    <li>
                      <Radio
                        label={translate('contents_header.menu.past_week')}
                        value="dttime_pw"
                        checked={radioValue === 'dttime_pw'}
                        onChange={handleRadioChange}
                      />
                    </li>
                    <li>
                      <Radio
                        label={translate('contents_header.menu.past_month')}
                        value="dttime_pm"
                        checked={radioValue === 'dttime_pm'}
                        onChange={handleRadioChange}
                      />
                    </li>
                    <li>
                      <Radio
                        label={translate('contents_header.menu.custom_range')}
                        value="dttime_cr"
                        checked={radioValue === 'dttime_cr'}
                        onChange={handleRadioChange}
                      />
                      <div className="date_range_picker_wrap" ref={ref}>
                        {radioValue === 'dttime_cr' ? (
                          <DatesRangeInput
                            className="date_range"
                            name="datesRange"
                            placeholder={translate('contents_header.place_holder.from_to')}
                            value={datesRange}
                            iconPosition="left"
                            onChange={handleDateRange}
                            closable
                            closeOnMouseLeave={false}
                            dateFormat={currentLocale === 'kr' || currentLocale === 'ja' ? 'YYYY-MM-DD' : 'DD-MM-YYYY'}
                          />
                        ) : null}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            )
          }
        </div>
      </div>
    </Scrollbars>
  );
});
CommonFilterList.displayName = 'CommonFilterList';
export default CommonFilterList;
